import { render, staticRenderFns } from "./pText.vue?vue&type=template&id=786b0861&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./pText.vue?vue&type=script&async=true&lang=js&"
export * from "./pText.vue?vue&type=script&async=true&lang=js&"
import style0 from "./pText.vue?vue&type=style&index=0&id=786b0861&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports